/**
 *
 * OEM Overrides helper functions
 *
 */

export function hasOEMSchedule(oemOverrides) {
	if (typeof oemOverrides !== 'undefined')
		return oemOverrides.useOverrides && oemOverrides.valid;

	return false;
}

export function getRateForTerm(term, oemOverrides) {
	let rate = 0;

	if (
		typeof term === 'number' &&
		Object.prototype.hasOwnProperty.call(oemOverrides.schedule, term) // make linter happy
	) {
		rate = oemOverrides.schedule[term];
	}

	return rate;
}

export function overrideInitialState(state) {
	const newState = state;

	newState.initial.selectedAprTerm = newState.oemOverrides.defaultTerm;
	newState.initial.apr = getRateForTerm(
		newState.initial.selectedAprTerm,
		newState.oemOverrides
	);

	return newState;
}

export function loadOemConfig(state, payload) {
	const newState = state;

	if (
		payload &&
		payload.paymentOptions &&
		payload.paymentOptions.defaultAprTerm >= 0 &&
		payload.paymentOptions.aprTermMap &&
		Object.getOwnPropertyNames(payload.paymentOptions.aprTermMap).length > 0
	) {
		newState.oemOverrides.defaultTerm =
			payload.paymentOptions.defaultAprTerm;
		newState.oemOverrides.schedule = payload.paymentOptions.aprTermMap;
		newState.oemOverrides.valid = true;
	}

	if (hasOEMSchedule(newState.oemOverrides)) {
		overrideInitialState(newState);
	}

	return newState;
}

export function isScheduleValid(state) {
	return (
		Object.getOwnPropertyNames(state.calculatorData.oemOverrides.schedule)
			.length > 0
	);
}

export function getTermList(state) {
	const termSchedule = state.calculatorData.oemOverrides.schedule;
	const termList = [];
	const terms = Object.keys(termSchedule);

	terms.forEach((prop) => {
		termList.push(parseInt(prop, 10));
	});

	return termList;
}
